import {
  IBalanceHistoryResult,
  IBalanceResponse,
  IBalanceResult,
} from "@/core/models/balance.model";

const balanceCompositionTransformer = (
  data: IBalanceResponse
): IBalanceResult["composition"] => ({
  co: {
    topGas: data.output.top_gas_co,
    tgScrubbed: data.output.tg_scrubbed_co,
    reformedGas: data.output.reformed_gas_co,
    bustleGas: data.output.bustle_gas_co,
    flueGas: data.output.flue_gas_co,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_co,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_co,
  },
  co2: {
    topGas: data.output.top_gas_co2,
    tgScrubbed: data.output.tg_scrubbed_co2,
    reformedGas: data.output.reformed_gas_co2,
    bustleGas: data.output.bustle_gas_co2,
    flueGas: data.output.flue_gas_co2,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_co2,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_co2,
  },
  h2: {
    topGas: data.output.top_gas_h2,
    tgScrubbed: data.output.tg_scrubbed_h2,
    reformedGas: data.output.reformed_gas_h2,
    bustleGas: data.output.bustle_gas_h2,
    flueGas: data.output.flue_gas_h2,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_h2,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_h2,
  },
  h2o: {
    topGas: data.output.top_gas_h2o,
    tgScrubbed: data.output.tg_scrubbed_h2o,
    reformedGas: data.output.reformed_gas_h2o,
    bustleGas: data.output.bustle_gas_h2o,
    flueGas: data.output.flue_gas_h2o,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_h2o,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_h2o,
  },
  n2: {
    topGas: data.output.top_gas_n2,
    tgScrubbed: data.output.tg_scrubbed_n2,
    reformedGas: data.output.reformed_gas_n2,
    bustleGas: data.output.bustle_gas_n2,
    flueGas: data.output.flue_gas_n2,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_n2,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_n2,
  },
  ch4: {
    topGas: data.output.top_gas_ch4,
    tgScrubbed: data.output.tg_scrubbed_ch4,
    reformedGas: data.output.reformed_gas_ch4,
    bustleGas: data.output.bustle_gas_ch4,
    flueGas: data.output.flue_gas_ch4,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_ch4,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_ch4,
  },
  c2h6: {
    topGas: data.output.top_gas_c2h6,
    tgScrubbed: data.output.tg_scrubbed_c2h6,
    reformedGas: data.output.reformed_gas_c2h6,
    bustleGas: data.output.bustle_gas_c2h6,
    flueGas: data.output.flue_gas_c2h6,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_c2h6,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_c2h6,
  },
  c3h8: {
    topGas: data.output.top_gas_c3h8,
    tgScrubbed: data.output.tg_scrubbed_c3h8,
    reformedGas: data.output.reformed_gas_c3h8,
    bustleGas: data.output.bustle_gas_c3h8,
    flueGas: data.output.flue_gas_c3h8,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_c3h8,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_c3h8,
  },
  c4h10: {
    topGas: data.output.top_gas_c4h10,
    tgScrubbed: data.output.tg_scrubbed_c4h10,
    reformedGas: data.output.reformed_gas_c4h10,
    bustleGas: data.output.bustle_gas_c4h10,
    flueGas: data.output.flue_gas_c4h10,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_c4h10,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_c4h10,
  },
  c5h12: {
    topGas: data.output.top_gas_c5h12,
    tgScrubbed: data.output.tg_scrubbed_c5h12,
    reformedGas: data.output.reformed_gas_c5h12,
    bustleGas: data.output.bustle_gas_c5h12,
    flueGas: data.output.flue_gas_c5h12,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_c5h12,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_c5h12,
  },
  c6h14: {
    topGas: data.output.top_gas_c6h14,
    tgScrubbed: data.output.tg_scrubbed_c6h14,
    reformedGas: data.output.reformed_gas_c6h14,
    bustleGas: data.output.bustle_gas_c6h14,
    flueGas: data.output.flue_gas_c6h14,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_c6h14,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_c6h14,
  },
  o2: {
    topGas: data.output.top_gas_o2,
    tgScrubbed: data.output.tg_scrubbed_o2,
    reformedGas: data.output.reformed_gas_o2,
    bustleGas: data.output.bustle_gas_o2,
    flueGas: data.output.flue_gas_o2,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_o2,
    feedGasAfterFeedGasMixer: data.output.feed_gas_after_feed_gas_mixer_o2,
  },
  flow: {
    topGas: data.output.top_gas_flow,
    tgScrubbed: data.output.tg_scrubbed_flow,
    reformedGas: data.output.reformed_gas_flow,
    bustleGas: data.output.bustle_gas_flow,
    flueGas: data.output.flue_gas_flow,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_flow,
    feedGasAfterFeedGasMixer: data.output.feed_after_feed_gas_mix_flow,
    streamToFeedMixer: data.output.added_steam_feedmixed,
  },
  temp: {
    bustleGas: data.output.bustle_gas_temp,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_temp,
    feedGasAfterFeedGasMixer: data.output.feed_after_feed_gas_mix_temp,
  },
  enthalpy: {
    topGas: data.output.top_gas_enthalpy,
    tgScrubbed: data.output.tog_gas_scrubbed_enthalpy,
    reformedGas: data.output.reformed_gas_enthalpy,
    bustleGas: data.output.bustle_gas_enthalpy,
    flueGas: data.output.flue_gas_to_stack_enthalpy,
    feedGasAfterPGMixer: data.output.feed_gas_after_pg_mixer_enthalpy,
    feedGasAfterFeedGasMixer:
      data.output.feed_gas_after_feed_gas_mixer_enthalpy,
  },
});

const balanceProductTransformer = (
  data: IBalanceResponse
): IBalanceResult["product"] => [
  {
    "1": data.output.A?.["1"] ?? "-",
    "2": data.output.A?.["2"] ?? "-",
    "GC/Mass": data.output.A?.["GC/Mass"] ?? "-",
  },
  {
    "1": data.output.B?.["1"] ?? "-",
    "2": data.output.B?.["2"] ?? "-",
    "GC/Mass": data.output.B?.["GC/Mass"] ?? "-",
  },
  {
    "1": data.output.C?.["1"] ?? "-",
    "2": data.output.C?.["2"] ?? "-",
    "GC/Mass": data.output.C?.["GC/Mass"] ?? "-",
  },
  {
    "1": data.output.utilization_a?.["1"] ?? "-",
    "2": data.output.utilization_b?.["1"] ?? "-",
    "GC/Mass": data.output.utilization_c?.["1"] ?? "-",
  },
];

const balanceReformerTransformer = (
  data: IBalanceResponse
): IBalanceResult["reformer"] => ({
  sensible_heat_to_tubes: data.output.sensible_heat_to_tubes,
  reaction_heat_to_tubes: data.output.reaction_heat_to_tubes,
  reformer_heat_losses: data.output.reformer_heat_losses,
  total_heat_released_by_fuel: data.output.total_heat_released_by_fuel,
});

const balanceRecuperatorTransformer = (
  data: IBalanceResponse
): IBalanceResult["recuperator"] => ({
  hot_air_bundle: data.output.hot_air_bundle,
  cold_air_bundle: data.output.cold_air_bundle,
  feed_gas: data.output.feed_gas,
  total_recovered: data.output.total_recovered,
  lost_to_stack: data.output.lost_to_stack,
  lost_to_seal: data.output.lost_to_seal,
});

export const balanceResultTransformer = (
  response: IBalanceResponse
): IBalanceResult => ({
  composition: balanceCompositionTransformer(response),
  product: balanceProductTransformer(response),
  reformer: balanceReformerTransformer(response),
  recuperator: balanceRecuperatorTransformer(response),
});

export const balanceHistoryTransformer = (
  response: IBalanceResponse[]
): IBalanceHistoryResult[] => {
  return response.map((balance) => ({
    id: balance.id,
    time: balance.created_at,
    ...balanceResultTransformer(balance),
  }));
};
